<script src="https://www.google.com/recaptcha/api.js"></script>

<template>
  <div class="main">
    <div class="d-flex justify-content-around align-center m-3">
      <img
        src="https://unicampo.coop.br/uploads/bkp/2022/portal/logo.png"
        height="60"
      />
    </div>
    <div class="container">
      <b-card>
        <h1 class="text-center fw-bold mb-4">CADASTRE-SE</h1>
        <p>
          Este cadastro é destinado para profissionais do agronegócio que desejam fazer parte da Unicampo.
        </p>
        <div class="row">
          <div class="col-lg-12">
            <b-form-group
              class="mb-3"
              label="Nome Completo (sem abreviações) *"
              invalid-feedback="Digite seu nome completo e sem abreviações"
            >
              <b-form-input
                v-model="dados.nome"
                @input="verificarNome(dados.nome)"
                type="text"
                :state="validacaoNome"
                autocomplete="off"
                maxlength="60"
                trim
              ></b-form-input>
              <div class="text-center">
                <p
                  v-if="dados.nome"
                  class="badge position-absolute"
                  :class="{
                    'bg-success': dados.nome.length !== 60,
                    'bg-danger': dados.nome.length === 60,
                  }"
                >
                  {{ dados.nome.length }} / 60
                </p>
              </div>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <b-form-group
              class="mb-3"
              label="CPF *"
              :invalid-feedback="mensagemCPF"
            >
              <b-form-input
                v-model="dados.cpf"
                @blur="verificaCPF()"
                v-mask="'###.###.###-##'"
                type="text"
                :state="validacaoCPF"
                trim
              ></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <b-form-group
              class="mb-3"
              label="Formação Profissional *"
              invalid-feedback="Selecione sua formação profissional"
              :state="state"
            >
              <multiselect
                @close="verificaFormacao()"
                v-model="dados.profissao"
                placeholder="Selecione"
                :show-labels="false"
                :options="optionProfissao"
                label="DISPLAY"
                :allow-empty="false"
              />
            </b-form-group>
          </div>
        </div>

        <!-- Campo de E-mail -->
        <div class="row">
          <div class="col-lg-12">
            <b-form-group
              class="mb-3"
              label="E-mail *"
              :invalid-feedback="mensagemEmail"
            >
              <b-form-input
                v-model="dados.email"
                @blur="verificarEmail()"
                type="text"
                :state="validacaoEmail"
                autocomplete="off"
                trim
              ></b-form-input>
            </b-form-group>
          </div>
        </div>

        <!-- Campo de Confirmação de E-mail -->
        <div class="row">
          <div class="col-lg-12">
            <b-form-group
              class="mb-3"
              label="Confirmação de e-mail *"
              invalid-feedback="Os e-mails digitados devem ser iguais"
            >
              <b-form-input
                v-model="dados.emailIgual"
                @blur="verificarEmailIgual()"
                type="text"
                :state="validacaoEmailIgual"
                @paste="disablePaste"
                trim
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div v-if="!tiraOrientacao">
            <p class="fst-italic text-danger" v-if="tamanhoSenha">
              De 10 à 20 caracteres
            </p>
            <p class="fst-italic text-danger" v-if="minusculaSenha">
              Letra minúscula
            </p>
            <p class="fst-italic text-danger" v-if="maiusculaSenha">
              Letra maiúscula
            </p>
            <p class="fst-italic text-danger" v-if="numeroSenha">Número</p>
            <p class="fst-italic text-danger" v-if="simbolosPermitidosSenha">
              Símbolos obrigatórios ! ? ¨ - *
            </p>
            <p class="fst-italic text-danger" v-if="simbolosNaoPermitidosSenha">
              Símbolos não permitidos "@", "#", "&", "/", "\", "+","espaço"
            </p>
        </div>
        
        <!-- Campo de Senha -->
        <div class="row">
          <b-form-group
            class="mb-3"
            label="Senha *"
            invalid-feedback="Digite uma Senha com todas as exigências"
          >
            <b-form-input
              v-model="dados.senha"
              :type="inputType"
              @input="verificarSenha(dados.senha)"
              :state="validacaoSenha"
              trim
              style="width: 96% !important; display: unset"
            ></b-form-input>
            <button
              class="btn btn-light btn-outline-secondary"
              type="button"
              @click="togglePassword()"
              tabindex="-1"
            >
              <i v-if="isPassword" class="mdi mdi-eye-outline"></i>
              <i v-else class="mdi mdi-eye-off-outline"></i>
            </button>
          </b-form-group>
        </div>

        <!-- Campo de Confirmação de Senha -->
        <div class="row">
          <b-form-group
            class="mb-3"
            label="Confirmação de senha *"
            invalid-feedback="As senhas devem ser iguais"
          >
            <b-form-input
              v-model="dados.senhaConfirmacao"
              @blur="verificarSenhaIgual()"
              @paste="disablePaste"
              :state="validacaoSenhaIgual"
              :type="inputType"
              trim
              style="width: 96% !important; display: unset"
            ></b-form-input>
            <button
              class="btn btn-light btn-outline-secondary"
              type="button"
              @click="togglePassword()"
              tabindex="-1"
            >
              <i v-if="isPassword" class="mdi mdi-eye-outline"></i>
              <i v-else class="mdi mdi-eye-off-outline"></i>
            </button>
          </b-form-group>
        </div>

        <!-- Bloco que será ocultado se for Pré Cadastrado -->
        
          <!-- Botões Limpar e Cadastrar -->
          <div class="row">
            <div v-if="isPreCadastrado">
              <div class="col-lg-12">
                <p>Seu CPF foi encontrado em nosso sistema, mas você ainda não está registrado como candidato. Para se tornar candidato(a), complete as informações acima e clique em 'Cadastrar'.</p>
              </div>
            </div>
            <div class="mt-1 d-flex justify-content-end">
              <b-button @click="limpaFormulário()" class="mt-1 me-1">
                <i class="mdi mdi-broom font-size-16 align-middle me-1"></i>
                LIMPAR
              </b-button>
              <b-button
                variant="success"
                @click="cadastrarCandidato()"
                class="mt-1"
                :disabled="disabledCadastro"
              >
                <i class="mdi mdi-check font-size-16 align-middle me-1"></i>
                CADASTRAR
              </b-button>
            </div>
          </div>
      </b-card>
      <div class="d-flex justify-content-center align-center m-3">
        <img
          src="https://unicampo.coop.br/uploads/bkp/2022/portal/oceparLogo.png"
          height="80"
        />
        <img
          src="https://unicampo.coop.br/uploads/bkp/2022/portal/somosCoopLogo.png"
          height="80"
        />
      </div>
    </div>

    <vue-recaptcha
      sitekey="6LebGvweAAAAAFnTI7kT4HBEvkfpo-mDg-Ndfq2D"
      size="invisible"
      @verify="verifyMethod"
      ref="recaptcha"
    >
    </vue-recaptcha>
  </div>
</template>



    
    
<script>
import Multiselect from "vue-multiselect";
import cpf from "@/components/formulario/cpf-input";
import email from "@/components/formulario/email-input";
import senha from "@/components/formulario/senha-input";
import { VueRecaptcha } from "vue-recaptcha";
import Swal from "sweetalert2";

export default {
  components: { Multiselect, cpf, email, senha, VueRecaptcha },
  layout: "empty",
  data() {
    return {
      dados: {
        nome: "",
        cpf: "",
        profissao: "",
        email: "",
        emailIgual: "",
        senha: "",
        senhaConfirmacao: "",
      },
      optionProfissao: [],
      validacaoNome: null,
      validacaoProfissao: null,
      validacaoCPF: null,
      mensagemCPF: "Digite um CPF válido",
      mensagemEmail: "Digite um E-mail válido",
      validacaoEmail: null,
      validacaoEmailIgual: null,
      validacaoSenha: null,
      validacaoSenhaIgual: null,
      tiraOrientacao: false,
      tamanhoSenha: true,
      minusculaSenha: true,
      maiusculaSenha: true,
      numeroSenha: true,
      simbolosPermitidosSenha: true,
      simbolosNaoPermitidosSenha: true,
      inputType: "password",
      isPreCadastrado: false,
    };
  },

  created() {
    this.preencheLKP();
  },

  computed: {
    disabledCadastro() {
      if (
        this.validacaoNome &&
        this.validacaoCPF &&
        this.validacaoEmail &&
        this.validacaoEmailIgual &&
        this.validacaoSenha &&
        this.validacaoProfissao &&
        this.validacaoSenhaIgual
      ) {
        return false;
      }
      return true;
    },
    state() {
      return this.validacaoProfissao;
    },
    isPassword() {
      return this.inputType === "password";
    },
  },

  methods: {
    verificaFormacao() {
      if (!this.dados.profissao) {
        this.validacaoProfissao = false;
      } else {
        this.validacaoProfissao = true;
      }
    },

    preencheLKP() {
    this.$http
      .get("api/cadastroCandidato/buscarLkpProfissao")
      .then((response) => {
        console.log(response.data);

        // Normaliza os dados recebidos da API
        this.optionProfissao = response.data.map(item => ({
          ...item,
          DISPLAY: item.DISPLAY || item.Descricao || item.descricao || "Sem nome"
        }));
      })
      .catch((error) => {
        console.error("Erro ao buscar profissões:", error);
      });
  },


    disablePaste(event) {
      event.preventDefault();
    },

    togglePassword() {
      this.inputType = this.isPassword ? "text" : "password";
    },

    verificaCPF() {
      // Reseta a mensagem de CPF inválido
      this.mensagemCPF = "Digite um CPF válido";
      this.validacaoCPF = this.$tools.validarCPF(this.dados.cpf);
      var cpf = this.dados.cpf.replace(/[^\d]+/g, "");

      if (this.validacaoCPF) {
        this.$http
          .get("api/cadastroCandidato/buscarCPFExiste/" + cpf)
          .then((response) => {
            const data = response.data;
            if (typeof data === 'string' && data.trim() !== "") {
              this.mensagemCPF = data;
              this.isPreCadastrado = false;
              this.mensagemCPF = "CPF já cadastrado em nosso sistema!";
              this.validacaoCPF = false;
            } else if (typeof data === 'object' && data !== null && Object.keys(data).length > 0) {
              // Caso o backend retorne um objeto com status
              if (data.status === "Pré Cadastrado") {
                this.isPreCadastrado = true;
              } else {
                this.isPreCadastrado = false;
                this.mensagemCPF = "CPF já cadastrado em nosso sistema!";
                this.validacaoCPF = false;
              }
            } else {
              this.isPreCadastrado = false;
            }
          });
      }
    },

    verificarEmail() {
      this.mensagemEmail = "Digite um E-mail válido";

      this.dados.email = (this.dados.email || "").toLowerCase().trim();

      if (!this.dados.email) {
        this.validacaoEmail = null;
        return;
      }

      this.validacaoEmail = this.$tools.validarEmail(this.dados.email);

      if (this.validacaoEmail) {
        this.$http
          .get("api/cadastroCandidato/buscarEmailExiste/" + encodeURIComponent(this.dados.email))
          .then((response) => {
            const data = response?.data;

            // Se vier string, remove espaços/quebras de linha
            const msg = (typeof data === "string") ? data.trim() : data;

            // Só considera "tem mensagem" se após trim ainda tiver conteúdo
            const temMensagem = (typeof msg === "string") ? msg.length > 0 : !!msg;

            if (temMensagem) {
              this.mensagemEmail = "E-mail já cadastrado em nosso sistema!";
              this.validacaoEmail = false;
            } else {
              this.verificarEmailIgual();
            }
          })
          .catch(() => {
            // opcional: trate erro de rede/api aqui
          });
      }
    },

    verificarEmailIgual() {
      this.dados.emailIgual = this.dados.emailIgual.toLowerCase();
      if (
        this.dados.emailIgual == this.dados.email &&
        this.dados.emailIgual != ""
      ) {
        this.validacaoEmailIgual = true;
        return;
      }
      this.validacaoEmailIgual = false;
    },

    verifyMethod(token) {
      this.$http
        .get("api/auth/recaptcha/" + token)
        .then((response) => {
          if (response.data.success) {
            this.login();
          } else {
            this.$tools.alerta("Recaptcha Invalido", "error");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    verificarNome(nome) {
      this.dados.nome = nome.toUpperCase();
      if (/^(?=.*\s)[\p{L}\s]{0,60}$/u.test(nome)) {
        // converte o nome para maiúsculas
        this.validacaoNome = true;
        return;
      } else {
        this.validacaoNome = false;
        return;
      }
    },

    verificarSenha(senha) {
    // Verifica se a senha tem pelo menos 10 caracteres e no máximo 20 caracteres
    if (senha.length < 10 || senha.length > 20) {
        this.tamanhoSenha = true;
    } else {
        this.tamanhoSenha = false;
    }

    // Verifica se a senha contém pelo menos uma letra minúscula
    if (!/[a-z]/.test(senha)) {
        this.minusculaSenha = true;
    } else {
        this.minusculaSenha = false;
    }

    // Verifica se a senha contém pelo menos uma letra maiúscula
    if (!/[A-Z]/.test(senha)) {
        this.maiusculaSenha = true;
    } else {
        this.maiusculaSenha = false;
    }

    // Verifica se a senha contém pelo menos um número
    if (!/\d/.test(senha)) {
        this.numeroSenha = true;
    } else {
        this.numeroSenha = false;
    }

    // Verifica se a senha contém caracteres não permitidos: @, #, &, %, ,, /, +
    if (/[@#&%,+\/\s   |]/.test(senha) || senha === "") {
        this.simbolosNaoPermitidosSenha = true;
    } else {
        this.simbolosNaoPermitidosSenha = false;
    }

    // Verifica se a senha contém caracteres permitidos: ! ? ¨ - *
    if (!/[!?¨\-*]/.test(senha) || senha === "") {
        this.simbolosPermitidosSenha = true;
    } else {
        this.simbolosPermitidosSenha = false;
    }

    // Se a senha passou por todas as verificações acima, então é uma senha válida
    this.validacaoSenha = !(
        this.tamanhoSenha ||
        this.minusculaSenha ||
        this.maiusculaSenha ||
        this.numeroSenha ||
        this.simbolosPermitidosSenha ||
        this.simbolosNaoPermitidosSenha
    );
},

    verificarSenhaIgual() {
      if (
        this.dados.senhaConfirmacao == this.dados.senha &&
        this.dados.senhaConfirmacao != ""
      ) {
        this.validacaoSenhaIgual = true;
        return;
      }
      this.validacaoSenhaIgual = false;
    },

    limpaFormulário() {
      this.dados.nome = "";
      this.dados.cpf = "";
      this.dados.profissao = "";
      this.dados.email = "";
      this.dados.emailIgual = "";
      this.dados.senha = "";
      this.dados.senhaConfirmacao = "";
      this.validacaoNome = null;
      this.validacaoCPF = null;
      this.validacaoProfissao = null;
      this.validacaoEmail = null;
      this.validacaoEmailIgual = null;
      this.validacaoSenha = null;
      this.validacaoSenhaIgual = null;
      this.tamanhoSenha = true;
      this.minusculaSenha = true;
      this.maiusculaSenha = true;
      this.numeroSenha = true;
      this.simbolosSenha = true;
    },

    cadastrarCandidato() {
  var item = {};
  item.nome = this.dados.nome;
  item.cpf = this.dados.cpf.replace(/\W/g, "");
  const prof = this.dados.profissao;
  item.profissao = parseInt(prof?.ID || prof?.Id || prof?.id);
  item.email = this.dados.email;
  item.senha = this.dados.senha;
      this.$http
        .post("api/cadastroCandidato/cadastrarNovoUsuario", item)
        .then(() => {
          Swal.fire({
            title: "<strong>Estamos quase lá...</strong>",
            icon: "success",
            html: "Você receberá um e-mail para confirmar o seu cadastro em até 24h. Após a confirmação, acesse o Portal Unicampo para finalizar o processo.",
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: true,
            focusConfirm: false,
          });
          this.$router.push({ path: "/login" });
        })
        .catch((err) => {
          const msg = err.response?.data?.data || err.response?.data?.message || 'Erro desconhecido.';
          Swal.fire({
            title: "<strong>Erro ao cadastrar usuário.</strong>",
            icon: "error",
            html: msg,
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: true,
            focusConfirm: false,
          });
        });
    },

    getLabel(option) {
      return option.DISPLAY || option.Descricao || '';
    },

  },
};
</script>
